import { useState, useEffect } from "react";

interface UseComponentHeightReturn {
  componentHeight: number;
}

export const useComponentHeight = (): UseComponentHeightReturn => {
  const [componentHeight, setComponentHeight] = useState<number>(600);

  useEffect(() => {
    const timer = setTimeout(() => {
      const calculateAvailableHeight = () => {
        const totalHeight = window.innerHeight;
        const headerHeight = 64 + 24;
        const footerHeight = 48 + 24;
        const topElementsHeight = 48;
        const gapHeight = 16;

        const availableHeight = totalHeight - headerHeight - footerHeight - topElementsHeight - gapHeight;
        const safeHeight = Math.floor(availableHeight * 0.98);

        return safeHeight;
      };

      const newHeight = calculateAvailableHeight();
      setComponentHeight(newHeight);
    }, 300);

    const handleResize = () => {
      const newHeight = window.innerHeight - 200;
      setComponentHeight(newHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    componentHeight,
  };
};
